import React from 'react'

export default function TablePagination({
  currentPage,
  totalPages,
  totalItems,
  rowsPerPage,
  onPrevious,
  onNext
}) {
  return null
}